import React, { useEffect, useState } from "react";
import DashboardLayout from "components/layouts/dashboard-layout";
import styled from "styled-components";
import { ReactComponent as Bg } from "images/svg/dashboardArtistBg.svg";
import { ReactComponent as MobileBg } from "images/svg/dashboardArtistMobileBg.svg";
import Menu from "./components/menu";
import ArtistProfile from "./components/artistProfile";
import ArtistMusicPlatforms from "./components/artistMusicPlatforms";
import PlanArtists from "./components/planArtist";
import SocialMedia from "./components/socialMedia";
import { useParams, useSearchParams } from "react-router-dom";

const DashboardArtists = () => {
  const [activeMenu, setActiveMenu] = useState("Artist Profile");

  const [searchParams] = useSearchParams();
  const createNew = searchParams.get("createNew");

  useEffect(() => {
    if (createNew) {
      setActiveMenu("Plan Artists");
    }
  }, [createNew]);

  return (
    <DashboardLayout>
      <Main>
        <Body>
          <Menu
            select={(menuItem) => setActiveMenu(menuItem)}
            selected={activeMenu}
          />

          {activeMenu === "Artist Profile" ? (
            <ArtistProfile />
          ) : activeMenu === "Artist Music Platforms" ? (
            <ArtistMusicPlatforms />
          ) : activeMenu === "Plan Artists" ? (
            <PlanArtists />
          ) : activeMenu === "Social Media" ? (
            <SocialMedia />
          ) : (
            <></>
          )}
        </Body>

        <BgImage>
          <Bg />
        </BgImage>
        <MobileBgImage>
          <MobileBg />
        </MobileBgImage>
      </Main>
    </DashboardLayout>
  );
};

export default DashboardArtists;

const Main = styled.div`
  position: relative;
`;

const Body = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 30% 70%;
  height: max-content;
  gap: 3.2rem;
  padding-top: 15%;
  z-index: 1;
  @media only screen and (max-width: 769px) {
    grid-template-columns: 100%;
    gap: 2.4rem;
    padding-top: 0;
  }
`;

const BgImage = styled.div`
  width: 110%;
  position: absolute;
  top: -5rem;
  left: -5%;
  z-index: 0;
  @media only screen and (max-width: 769px) {
    display: none;
  }
`;
const MobileBgImage = styled.div`
  position: absolute;
  width: 110%;
  top: -5rem;
  left: -5%;
  display: none;
  z-index: 0;
  @media only screen and (max-width: 769px) {
    display: flex;
  }
`;
